import { css } from "styled-components";

// IE9+ CSS for more info see
// https://stackoverflow.com/questions/18907131/detecting-ie11-using-css-capability-feature-detection
// eslint-disable-next-line
export default function ie9andAboveOnly(arg, ...args) {
  return css`
    @media screen and (min-width: 0\0) and (min-resolution: +72dpi) {
      ${css(arg, ...args)};
    }
  `;
}
